// extracted by mini-css-extract-plugin
export default {"featurePanel":"SystemHealthSummary_featurePanel__9eL7T","disabledFeaturePanel":"SystemHealthSummary_disabledFeaturePanel__CQWur"};